import {Component, computed, input, model, output, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslocoPipe} from '@jsverse/transloco';
import {Button} from 'primeng/button';
import {Checkbox} from 'primeng/checkbox';
import {Dialog} from 'primeng/dialog';
import {TemplateFillSummary} from './template-fill.types';

@Component({
  selector: 'app-template-fill-dialog',
  imports: [FormsModule, TranslocoPipe, Button, Checkbox, Dialog],
  templateUrl: './template-fill-dialog.component.html',
})
export class TemplateFillDialogComponent {
  readonly visible = model(false);
  readonly summary = input.required<TemplateFillSummary>();
  readonly filling = input(false);

  readonly confirmed = output<boolean>();

  protected readonly overwriteAnswered = signal(false);
  protected readonly canConfirm = computed(
    () => this.summary().fillableCount > 0 || this.overwriteAnswered(),
  );

  protected onVisibleChange(visible: boolean): void {
    this.visible.set(visible);
    this.overwriteAnswered.set(false);
  }

  protected onConfirm(): void {
    this.confirmed.emit(this.overwriteAnswered());
  }
}
